"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareFegoEventChannel = exports.CHANNEL_MAP = void 0;
exports.reportFtEvent = reportFtEvent;
const tslib_1 = require("tslib");
/*eslint-disable no-eq-null,eqeqeq */
const fego_render_1 = tslib_1.__importDefault(require("@futuweb/fego-render"));
/**
 * 事件上报
 * @param { string } eventName 事件名称
 * @param { object } property 事件属性
 * @param { number } eventVersion 事件版本
 * @returns { void }
 */
function reportFtEvent(eventName, property = {}, eventVersion = 1) {
    var _a, _b;
    try {
        if ((_b = (_a = fego_render_1.default === null || fego_render_1.default === void 0 ? void 0 : fego_render_1.default.plugins) === null || _a === void 0 ? void 0 : _a.ftReport) === null || _b === void 0 ? void 0 : _b.ftReportIns) {
            // 测试环境使用设置isTest为true并配置host：http://test.hosts.futuoa.com/hosts/get-hosts-content?id=10244
            // FEGORender.plugins.ftReport.ftReportIns.setOptions({
            //     isTest: true,
            // });
            fego_render_1.default.plugins.ftReport.ftReportIns.sdReport({
                eventName,
                eventVersion,
                payload: property,
            });
        }
    }
    catch (error) {
        console.error('error:', error);
    }
}
// channel分享上报映射值
exports.CHANNEL_MAP = {
    niuyou: '4',
    chatRoom: '6',
    nnq: '5',
    wxFriend: '0',
    wxTimeline: '1',
    qq: '2',
    weibo: '3',
    facebook: '7',
    twitter: '8',
    whatsapp: '9',
    dingtalk: '16',
    line: '17',
    telegram: '18',
    other: '10',
    instagram: '12',
    sms: '13',
    email: '14',
    copy: '15'
};
exports.ShareFegoEventChannel = {
    facebook: 'facebook',
    twitter: 'x',
    telegram: 'telegram',
    xiaohongshu: 'xiaohongshu',
    reddit: 'reddit',
    wxFriend: 'wechat_friend', // 微信好友
    wechat_moments: 'wechat_moments', // 微信朋友圈
    qq: 'qq', // QQ
    weibo: 'sina_weibo', // 新浪微博
    chatRoom: 'chat', // 聊天室
    nnq: 'feed', // 牛牛圈、moomoo圈
    whatsapp: 'whats_app',
    sms: 'sms',
    email: 'email',
    copy: 'copy',
    instagram: 'instagram',
    dingtalk: 'dingding',
    line: 'line',
    more: 'more',
};
setTimeout(() => {
    let _window;
    if (window['Super_IPO_Season_click']) {
        return;
    }
    window['Super_IPO_Season_click'] = true;
    const actSign = 'Super_IPO_Season';
    const pageViwName = 'Super_IPO_Season_view';
    const pageViwName8s = 'Super_IPO_Season_view8s';
    const pageClickName = 'Super_IPO_Season_click';
    const getFtReport = (_window = window) == null
        || (_window = _window.FEGORender) == null ? void 0 : _window.getFtReport;
    if (!getFtReport) {
        return;
    }
    const ftReportIns = getFtReport();
    function getGlobalContent() {
        try {
            const url = new URL(location.href);
            const params = url.searchParams;
            const global_content_str = params.get('global_content') || '';
            return global_content_str;
        }
        catch (e) {
            console.error('解析global_content失败', e);
            return '';
        }
    }
    function reportClick() {
        ftReportIns == null || ftReportIns.sdReport({
            eventName: 'ClickPageEffectively',
            eventVersion: 3,
            eventEntity: 'NiuNiu',
            // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
            payload: {
                union_id: pageClickName,
                act_sign: actSign,
                global_content: getGlobalContent()
            }
        });
    }
    function reportViewPage() {
        ftReportIns == null || ftReportIns.sdReport({
            eventName: 'ViewPageEffectively',
            eventVersion: 3,
            eventEntity: 'NiuNiu',
            // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
            payload: {
                union_id: pageViwName,
                act_sign: actSign,
                global_content: getGlobalContent()
            }
        });
        setTimeout(() => {
            ftReportIns == null || ftReportIns.sdReport({
                eventName: 'ViewPageEffectively',
                eventVersion: 3,
                eventEntity: 'NiuNiu',
                // entity -- 获取活动信息接口 entity字段 （FUTU_SG， FUTU_HK.....）
                payload: {
                    union_id: pageViwName8s,
                    act_sign: actSign,
                    event_duration: 8000,
                    global_content: getGlobalContent()
                }
            });
        }, 8000);
    }
    reportViewPage();
    window.addEventListener('click', (event) => {
        const target = event.target;
        // 判断父节点与本节点是否有a标签
        // 判断父节点与本节点是否有fegoevt-n-click 属性
        // 判断是否是button
        if (target.tagName === 'A'
            || target.closest('a')
            || target.hasAttribute('fegoevt-n-click')
            || target.closest('[fegoevt-n-click]')
            || target.tagName === 'BUTTON'
            || target.closest('button')) {
            reportClick();
        }
    });
}, 300);
//# sourceMappingURL=data:application/json;base64,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